import { createContext } from "react";

export type TableSortDir = "asc" | "desc";

export enum TableTheme {
  default = "default",
  whiteHeader = "whiteHeader",
}

export enum TableSticky {
  none = "none",
  onlyTop = "onlyTop",
  onlyLeft = "onlyLeft",
  topAndLeft = "topAndLeft",
}

export const TableThemeContext = createContext(TableTheme.default);
export const TableStickyContext = createContext(TableSticky.none);
